import styled from 'styled-components';
import { Divider as ANTDivider, Typography, Input as ANTInput } from 'antd';

export const Divider = styled(ANTDivider)`
    margin: 0 !important;
`;

export const Title = styled(Typography.Title)`
    margin: 0 !important;
`;
export const Input = styled(ANTInput)`
    width: 283px;
`;
